"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheHearthHeritage() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="244972" id="آشنایی-کوتاه-با-دکتر-مهرنوش-اسماعیلی" className="py-32 lg:py-48 bg-accent/80 text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out group ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply z-10 pointer-events-none"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/psychologist_desk_natural_light_plants.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/psychologist_desk_natural_light_plants.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/psychologist_desk_natural_light_plants.png-wvc-sizes" alt="دکتر مهرنوش اسماعیلی در دفتر کار با نور طبیعی و گیاهان" className="object-cover w-full h-full contrast-105 brightness-100 transition-transform duration-700 ease-in-out group-hover:scale-105" loading="lazy" />
            <div className="absolute inset-4 border border-background/20 z-20 rounded-xl pointer-events-none"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out bg-white/40 backdrop-blur-sm p-8 lg:p-12 rounded-2xl shadow-xl ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-12 bg-secondary block"></span>
              <span className="text-sm font-default font-medium tracking-widest text-secondary uppercase">درباره من</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-default font-extrabold text-foreground mb-12 leading-tight after:content-[''] after:block after:h-1.5 after:w-24 after:bg-secondary after:mt-4">
              داستان من
            </h2>
            
            <div className="space-y-12">
              <p className="text-lg md:text-xl leading-loose md:leading-loose text-foreground/90">
                همه چیز با یک پرسش آغاز شد:
                <br /><br />
                چرا بعضی افراد با وجود استعداد، توانایی و فرصت‌های فراوان، احساس رضایت و آرامش نمی‌کنند، در حالی که برخی دیگر حتی در دشوارترین شرایط مسیر رشد و شکوفایی خود را پیدا می‌کنند؟
                <br /><br />
                این پرسش سال‌ها ذهن مرا به خود مشغول کرد و به اشتیاقی عمیق برای شناخت ذهن انسان، هیجان‌ها، روابط و ظرفیت‌های پنهان او تبدیل شد.
              </p>
              
              <p className="text-lg leading-loose text-foreground/90 font-default">
                این مسیر از دانشگاه علوم پزشکی اصفهان آغاز شد؛ جایی که نخستین گام‌های جدی خود را در دنیای علم و پژوهش برداشتم. سال‌ها مطالعه، پژوهش، تدریس و تجربه‌های علمی، نگاه مرا به انسان و پیچیدگی‌های ذهن او عمیق‌تر کرد و در نهایت مرا به دریافت دکتری تخصصی روان‌شناسی رساند.
                <br /><br />
                در طول این سال‌ها، علاوه بر فعالیت‌های پژوهشی و حرفه‌ای، به عنوان مدرس دانشگاه نیز فرصت داشتم دانش و تجربیات خود را با دانشجویان به اشتراک بگذارم؛ تجربه‌ای ارزشمند که باور مرا به قدرت آموزش، یادگیری و رشد انسانی بیش از پیش تقویت کرد.
              </p>
            </div>
          </div>

          {}
          <div className={`lg:col-span-2 mt-4 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <p className="text-lg leading-loose text-foreground/90 font-default bg-white/40 backdrop-blur-sm p-8 rounded-2xl shadow-xl">
              من باور دارم که هر تحول بزرگی از یک آگاهی کوچک آغاز می‌شود.
              <br /><br />
              و به همین دلیل، فلسفه تمام فعالیت‌های حرفه‌ای من در یک جمله خلاصه می‌شود:
              <br /><br />
              <span className="font-bold text-primary">«آگاهی، شروع مسیر شکوفایی است.»</span>
              <br /><br />
              دکتر مهرنوش اسماعیلی
              <br />
              دکتری تخصصی روان‌شناسی | مدرس دانشگاه | پژوهشگر علوم اعصاب و توسعه فردی | فعال حوزه رشد و شکوفایی انسانی
            </p>
          </div>

        </div>
      </div>
    </section>;
}